// extracted by mini-css-extract-plugin
export default {"div":"Pay_div__k1zCZ","paymentdiv":"Pay_paymentdiv__zlOnv","button":"Pay_button__IRxyw","add":"Pay_add__s1kg2"};